import { TablePagination } from '@mui/material';

import { CustomPaginationProps } from '@/core';
import palette from '@/theme/palette.ts';

export const CustomPagination = ({
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  rowsPerPageOptions,
  rowCount,
}: CustomPaginationProps) => {
  return (
    <TablePagination
      component="div"
      count={rowCount}
      page={page}
      rowsPerPage={pageSize}
      onPageChange={(_, newPage) => onPageChange(newPage)}
      onRowsPerPageChange={(event) => onPageSizeChange(parseInt(event.target.value, 10))}
      rowsPerPageOptions={rowsPerPageOptions}
      sx={{
        '& .MuiTablePagination-selectLabel': {
          fontSize: '0.75rem',
          fontWeight: '400',
          color: palette.text.info,
        },
        '& .MuiTablePagination-select': {
          fontSize: '0.75rem',
          fontWeight: '400',
          marginTop: '3px',
          color: palette.text.primary,
        },
        '& .MuiTablePagination-displayedRows': {
          color: palette.text.primary,
          fontSize: '0.75rem',
          fontWeight: '400',
        },
        '& .MuiTablePagination-actions': {
          '& .MuiIconButton-root': {
            color: palette.arrow.active,
          },
        },
        '& .MuiIconButton-root.Mui-disabled': {
          color: palette.arrow.disabled,
        },
      }}
    />
  );
};
